"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedditIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Reddit_svg_1 = __importDefault(require("./Reddit.svg"));
/**
 * Reddit icon
 * figma link - https://www.figma.com/file/M9VCQnWUmAbbRy9VXOtlwO/Atomic-Icons?node-id=916%3A916
 */
function RedditIcon() {
    return (0, jsx_runtime_1.jsx)(Reddit_svg_1.default, {});
}
exports.RedditIcon = RedditIcon;
//# sourceMappingURL=RedditIcon.js.map